/* ================================
All Swiper Scripts 
================================ */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.key-ing').forEach(function (el) {
    var totalSlides   = el.querySelectorAll('.swiper-slide').length;

    // Treat your data attributes as the maximum per breakpoint
    var maxDesktop = parseInt(el.getAttribute('data-slides-desktop') || '3', 10);
    var maxMobile  = parseInt(el.getAttribute('data-slides-mobile')  || '1', 10);

    // Compute how many to show per view, never more than total
    var perViewDesktop = Math.min(totalSlides, maxDesktop);
    var perViewMobile  = Math.min(totalSlides, maxMobile);

    var paginationEl = el.querySelector('.swiper-pagination.ki');
    var nextEl = el.querySelector('.swiper-button-next.ki');
    var prevEl = el.querySelector('.swiper-button-prev.ki');

    var swiperOptions = {
      slidesPerView: perViewMobile,
      watchOverflow: true,
      breakpoints: {
        990: {
          slidesPerView: perViewDesktop
        }
      }
    };

    if (paginationEl) {
      swiperOptions.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    if (nextEl && prevEl) {
      swiperOptions.navigation = {
        nextEl: nextEl,
        prevEl: prevEl
      };
    }

    var swiper = new Swiper(el, swiperOptions);

    // If everything fits on one page, hide controls
    var controlsShouldShowDesktop = totalSlides > perViewDesktop;
    var controlsShouldShowMobile  = totalSlides > perViewMobile;

    function updateControls() {
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var show = isDesktop ? controlsShouldShowDesktop : controlsShouldShowMobile;

      if (nextEl && prevEl) {
        nextEl.style.display = show ? '' : 'none';
        prevEl.style.display = show ? '' : 'none';
      }
      if (paginationEl) {
        paginationEl.style.display = show ? '' : 'none';
      }
    }

    updateControls();
    window.addEventListener('resize', updateControls);
  });
});


/* --------------------------------
Mobile Prod Gallery
--------------------------------- */
var mobileProdgallSwiper = new Swiper(".mobprodgall", {
      slidesPerView: 1,
      spaceBetween: 8,
  pagination: {
        el: ".swiper-pagination.mpg",
        clickable: true,
      },
});

/* --------------------------------
How to Use Swiper
--------------------------------- */
var howtoUseSwiper = new Swiper(".howtouse-swiper", {
  slidesPerView: 4,
  spaceBetween: 24,
  pagination: { el: ".swiper-pagination.htu", clickable: true },

  // key bits
  centerInsufficientSlides: true,
  watchOverflow: true,

  breakpoints: {
    320:  { slidesPerView: 1.2, spaceBetween: 16 },
    480:  { slidesPerView: 1,   spaceBetween: 24 },
    768:  { slidesPerView: 3,   spaceBetween: 24 },
    1024: { slidesPerView: 3,   spaceBetween: 24 },
    1280: { slidesPerView: 4,   spaceBetween: 24 }
  }
});


/* --------------------------------
Sub Collections Swiper
--------------------------------- */
var subColsSwiper = new Swiper(".subcols", {
      slidesPerView: 5.2,
  freeMode: true,
      spaceBetween: 8,
  pagination: {
        el: ".swiper-pagination.subc",
        clickable: true,
      },
        breakpoints: {
        320: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        480: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 4.2,
          spaceBetween: 8,
        },
        1280: {
          slidesPerView: 5.2,
          spaceBetween: 8,
        },
      }
});

/* --------------------------------
Blog Tags Swiper
--------------------------------- */
var blogTagsSwiper = new Swiper(".blogtags", {
      slidesPerView: 5.2,
  freeMode: true,
      spaceBetween: 8,
  pagination: {
        el: ".swiper-pagination.bt",
        clickable: true,
      },
        breakpoints: {
        320: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        480: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: 4.2,
          spaceBetween: 8,
        },
        1280: {
          slidesPerView: 5.2,
          spaceBetween: 8,
        },
      }
});

/* --------------------------------
Featured Collection Swiper
--------------------------------- */
var featuredCollectionSwiper = new Swiper(".feat-coll-swiper", {
      slidesPerView: 4,
      spaceBetween: 24,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  pagination: {
        el: ".swiper-pagination.fc",
        clickable: true,
      },
        breakpoints: {
        320: {
          slidesPerView: 1.25,
          spaceBetween: 16,
        },
        480: {
          slidesPerView: 1.25,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      }
});

/* --------------------------------
Hero Swiper
--------------------------------- */
const wrapper = document.querySelector('.hero-slideshow-wrapper');

if (wrapper) {
  const autoplayEnabled = wrapper.dataset.autoplay === 'true';
  const autoplayDelay = parseInt(wrapper.dataset.delay, 10) || 5000;

  const heroSwiper = new Swiper('.heroslideshow', {
    pagination: {
      el: '.swiper-pagination.hs',
      clickable: true,
    },
    autoHeight: true,          // key feature
    observer: true,            // watch slide content changes
    observeParents: true,      // watch parent size changes
    preloadImages: false,      // avoid blocking on image decode
    lazy: { loadOnTransitionStart: true },
    autoplay: autoplayEnabled
      ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
        }
      : false,
    on: {
      init() {
        this.updateAutoHeight();
      },
      imagesReady() {
        this.updateAutoHeight();
      },
      slideChangeTransitionEnd() {
        this.updateAutoHeight();
      },
    },
  });

  // If some images are not using Swiper lazy, also listen for native loads
  document.querySelectorAll('.heroslideshow .swiper-slide img').forEach(img => {
    if (!img.complete) {
      img.addEventListener('load', () => heroSwiper.updateAutoHeight());
    }
  });
}



/* --------------------------------
Blog Swiper
--------------------------------- */
var blogSwiper = new Swiper(".blogswipe", {
      slidesPerView: 4,
      spaceBetween: 24,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination.bs",
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.25,
          spaceBetween: 16,
        },
        480: {
          slidesPerView: 1.25,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      }
});

/* --------------------------------
Footer USPS Swiper
--------------------------------- */
var footerUspSwiper = new Swiper(".footerusps", {
    slidesPerView: 1,
    spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination.fu",
        clickable: true,
      },
      breakpoints: {
        1168: {
          slidesPerView: 4,
          spaceBetween: 64,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 10,
        }
      }
});

/* --------------------------------
Solutions Swiper
--------------------------------- */
var solutionSwiperContainer = document.querySelector(".solution-swiper");
var customColumns = solutionSwiperContainer ? parseInt(solutionSwiperContainer.dataset.columns) : 6;

var solutionsSwiper = new Swiper(".solutions-swiper", {
  slidesPerView: 6,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination.ss",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
    1280: {
      slidesPerView: customColumns,
      spaceBetween: 16,
    },
  },
});

/* --------------------------------
Main Product Image Gallery
--------------------------------- */
var productGallerySwiperThumbs = new Swiper(".thumbsgall", {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 6,
      navigation: {
        nextEl: ".swiper-button-next.tn",
        prevEl: ".swiper-button-prev.tn",
      },
  freeMode: true,
      watchSlidesProgress: true,
    });

var productGallerySwiperMain = new Swiper(".maingall", {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: productGallerySwiperThumbs,
      },
});

/* --------------------------------
Promo Swiper
--------------------------------- */
var promoSwiper = new Swiper(".promos", {
      slidesPerView: 3,
      spaceBetween: 24,
      pagination: {
        el: ".swiper-pagination.ps",
      },
          breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    }
});

/* --------------------------------
Testimonials Swiper
--------------------------------- */
var testimonialsSwiper = new Swiper(".testimonials", {
      slidesPerView: 3,
      spaceBetween: 24,
              breakpoints: {
        320: {
          slidesPerView: 1.15,
          spaceBetween: 16,
        },
        480: {
          slidesPerView: 1.15,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
  pagination: {
        el: ".swiper-pagination.ts",
        clickable: true,
      },
});

/* --------------------------------
USP Slider
--------------------------------- */
  var uspSlider = new Swiper(".uspslider", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next.usp",
      prevEl: ".swiper-button-prev.usp",
    },
    breakpoints: {
            // when window width is <= 768px (mobile-ish)
      1168: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      // when window width is <= 768px (mobile-ish)
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      // when window width is <= 480px (small mobile)
      480: {
        slidesPerView: 1,
        spaceBetween: 10,
      }
    }
  });

/* --------------------------------
Annoucement Swiper
--------------------------------- */
var annoucementSwiper = new Swiper(".annbar", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next.ab",
      prevEl: ".swiper-button-prev.ab",
    },
});